import SmartSearchDateActions from "../../../components/Layouts/smart-search-date-actions";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { DateFormatEnum } from "../../../enums/dateFormatEnum";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import { getReport } from "../../../services/reports";
import endpoints from "../../../utils/endpoints";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";

function ReportDeviceUtilization() {
  return (
    <SmartSearchDateActions
      searchBy={[
        SearchOptionEnum.DISTRIBUTOR,
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      actions={[
        ActionButtonEnum.REFRESH,
        ActionButtonEnum.SAVE_CSV,
        ActionButtonEnum.SAVE_PDF,
      ]}
      validateSearch={false}
      dateInputLabel="Reference Date"
      onRefresh={(output, params, date) => {
        const getReportParams: Record<string, any> = {
          name: "Device Utilization",
          output,
          date: date.format(DateFormatEnum.MONTH_DAY_YEAR),
        };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getReportParams[id] = params.id;
        }

        return getReport(
          getReportParams,
          endpoints.getDeviceUtilization,
          output
        );
      }}
    />
  );
}

export default ReportDeviceUtilization;
